/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const GreaterThanRevision: core.serialization.ObjectSchema<
    serializers.GreaterThanRevision.Raw,
    Truvity.GreaterThanRevision
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace GreaterThanRevision {
    export interface Raw {
        value: number;
    }
}
